























































import Vue from "vue";

export default Vue.extend({
  name: "Header",
  data() {
    return {
      menuOpen: false,
      navItems: [
        { to: "/imc", icon: "⚖️", labelKey: "nav.imc" },
        { to: "/Grasa-Corporal", icon: "🔬", labelKey: "nav.grasa" },
        { to: "/Calorias-Diarias", icon: "⚡", labelKey: "nav.calorias" },
        { to: "/Macros-Diarios", icon: "🥗", labelKey: "nav.macros" },
      ],
    };
  },
  methods: {
    toggleLocale() {
      const next = this.$i18n.locale === "es" ? "en" : "es";
      this.$i18n.locale = next;
      localStorage.setItem("locale", next);
    },
  },
});
